<div class="itinerary-page">

  <!-- Header -->
  <div class="itinerary-header">
    <h1>Itinerary</h1>
    <button class="btn btn-primary" (click)="openFormModal()">+ Add Item</button>
  </div>

  <div class="itinerary-layout" [class.has-panel]="showRightPanel">

    <!-- Left: day groups -->
    <div class="itinerary-list">
      <div *ngIf="items.length === 0" class="empty-state">
        <p class="empty-message">No items yet. Start planning your trip!</p>
        <button class="btn btn-primary" (click)="openFormModal()">Add your first item</button>
      </div>

      <div *ngFor="let day of groupedDays"
           class="day-group"
           [class.drag-over]="dragOverDate === day.date"
           (dragover)="onDragOver($event, day.date)"
           (drop)="onDrop($event, day.date)">
        <div class="day-header" (click)="toggleDay(day.date)">
          <span>📅 {{ day.label }}</span>
          <div class="day-header-actions">
            <button class="btn-add-day" (click)="openFormModalForDay(day.date); $event.stopPropagation()">+</button>
            <span class="collapse-icon" [class.collapsed]="isDayCollapsed(day.date)">▼</span>
          </div>
        </div>
        <div class="day-items" *ngIf="!isDayCollapsed(day.date)">
          <div class="itinerary-card"
               *ngFor="let item of day.items"
               [class.active]="selectedItem?.id === item.id"
               draggable="true"
               (dragstart)="onDragStart(item)"
               (dragend)="onDragEnd()"
               (click)="openItemModal(item)">
            <div class="card-left">
              <ng-container *ngIf="getCategoryConfig(item.category) as cat">
                <span class="category-badge"
                  [style.background]="cat.bgColor"
                  [style.color]="cat.textColor">
                  {{ cat.emoji }} {{ cat.label }}
                </span>
              </ng-container>
              <span class="item-name">{{ item.name }}</span>
            </div>
            <div class="item-time" *ngIf="item.time">{{ formatTime(item.time) }}</div>
          </div>
        </div>
      </div>
      <!-- Unscheduled items (mobile only — desktop shows these in right column) -->
      <div class="undated-panel mobile-undated" *ngIf="undatedItems.length > 0">
        <div class="undated-panel-header">
          <span>Unscheduled</span>
        </div>
        <div *ngFor="let item of undatedItems"
             class="undated-item"
             [class.active]="selectedItem?.id === item.id"
             (click)="openItemModal(item)">
          <div class="card-left">
            <ng-container *ngIf="getCategoryConfig(item.category) as cat">
              <span class="category-badge"
                [style.background]="cat.bgColor"
                [style.color]="cat.textColor">
                {{ cat.emoji }} {{ cat.label }}
              </span>
            </ng-container>
            <span class="item-name">{{ item.name }}</span>
          </div>
        </div>
      </div>

    </div>

    <!-- Right: detail panel + undated items -->
    <div class="right-column" *ngIf="showRightPanel">

      <!-- Detail panel -->
      <div class="detail-panel" *ngIf="selectedItem">
        <div class="detail-panel-header">
          <h5 class="detail-panel-title">{{ selectedItem.name }}</h5>
          <button class="detail-close-btn" (click)="closeItemModal()">✕</button>
        </div>
        <div class="detail-panel-body">
          <ng-container *ngIf="getCategoryConfig(selectedItem.category) as cat">
            <div class="detail-row">
              <span class="detail-label">Category</span>
              <span class="category-badge" [style.background]="cat.bgColor" [style.color]="cat.textColor">
                {{ cat.emoji }} {{ cat.label }}
              </span>
            </div>
          </ng-container>
          <div class="detail-row" *ngIf="selectedItem.date">
            <span class="detail-label">Date</span>
            <span>{{ selectedItem.date | date:'fullDate' }}</span>
          </div>
          <div class="detail-row" *ngIf="selectedItem.time">
            <span class="detail-label">Time</span>
            <span>{{ formatTime(selectedItem.time) }}</span>
          </div>
          <div class="detail-row" *ngIf="selectedItem.location">
            <span class="detail-label">Location</span>
            <span>{{ selectedItem.location }}</span>
          </div>
          <div class="detail-row" *ngIf="selectedItem.link">
            <span class="detail-label">Link</span>
            <a [href]="selectedItem.link" target="_blank" rel="noopener noreferrer">{{ selectedItem.link }}</a>
          </div>
          <div class="detail-row" *ngIf="selectedItem.cost != null">
            <span class="detail-label">Cost</span>
            <span>{{ selectedItem.cost | currency }}</span>
          </div>
          <div class="detail-row" *ngIf="selectedItem.notes">
            <span class="detail-label">Notes</span>
            <span class="notes-text">{{ selectedItem.notes }}</span>
          </div>
        </div>
        <div class="detail-panel-footer">
          <button class="btn btn-outline-danger" (click)="deleteItem(selectedItem)">Delete</button>
          <button class="btn btn-primary" (click)="openEditModal(selectedItem)">Edit</button>
        </div>
      </div>

      <!-- Undated items -->
      <div class="undated-panel"
           [class.drag-over]="dragOverUnscheduled"
           (dragover)="onDragOverUnscheduled($event)"
           (drop)="onDropUnscheduled($event)"
           *ngIf="undatedItems.length > 0 || draggingItem?.date">
        <div class="undated-panel-header">
          <span>Unscheduled</span>
          <span class="undated-hint">drag items to schedule</span>
        </div>
        <div class="undated-empty" *ngIf="undatedItems.length === 0">Drop here to unschedule</div>
        <div *ngFor="let item of undatedItems"
             class="undated-item"
             [class.active]="selectedItem?.id === item.id"
             draggable="true"
             (dragstart)="onDragStart(item)"
             (dragend)="onDragEnd()"
             (click)="openItemModal(item)">
          <span class="drag-grip">⠿</span>
          <div class="card-left">
            <ng-container *ngIf="getCategoryConfig(item.category) as cat">
              <span class="category-badge"
                [style.background]="cat.bgColor"
                [style.color]="cat.textColor">
                {{ cat.emoji }} {{ cat.label }}
              </span>
            </ng-container>
            <span class="item-name">{{ item.name }}</span>
          </div>
        </div>
      </div>

    </div>

  </div>

  <!-- Add/Edit Modal -->
  <div class="modal-backdrop" *ngIf="showFormModal">
    <div class="modal-dialog-centered modal-itinerary-form">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ editingItemId ? 'Edit Item' : 'Add Item' }}</h5>
          <button type="button" class="detail-close-btn" (click)="closeFormModal()">✕</button>
        </div>
        <div class="modal-body">
          <label class="form-label">Name *</label>
          <input type="text" class="form-control mb-3" [(ngModel)]="newItem.name" required>

          <div class="row g-2 mb-3">
            <div class="col-6">
              <label class="form-label">Date</label>
              <input type="date" class="form-control" [(ngModel)]="newItem.date">
            </div>
            <div class="col-6">
              <label class="form-label">Time</label>
              <input type="time" class="form-control" [(ngModel)]="newItem.time">
            </div>
          </div>

          <label class="form-label">Category</label>
          <div class="category-picker mb-3">
            <button
              *ngFor="let cat of categories"
              type="button"
              class="category-btn"
              [class.selected]="newItem.category === cat.value"
              [style.--cat-bg]="cat.bgColor"
              [style.--cat-text]="cat.textColor"
              (click)="newItem.category = newItem.category === cat.value ? undefined : cat.value">
              {{ cat.emoji }} {{ cat.label }}
            </button>
          </div>

          <label class="form-label">Link</label>
          <input type="url" class="form-control mb-3" [(ngModel)]="newItem.link" placeholder="https://...">

          <label class="form-label">Location</label>
          <input type="text" class="form-control mb-3" [(ngModel)]="newItem.location" placeholder="Address or place name">

          <label class="form-label">Cost ($)</label>
          <input type="number" class="form-control mb-3" [(ngModel)]="newItem.cost" placeholder="0.00" min="0" step="0.01">

          <label class="form-label">Notes</label>
          <textarea class="form-control" [(ngModel)]="newItem.notes" rows="3"></textarea>

          <div *ngIf="formError" class="alert alert-danger mt-2">{{ formError }}</div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-secondary" (click)="closeFormModal()">Cancel</button>
          <button class="btn btn-primary" (click)="saveItem()">
            {{ editingItemId ? 'Update Item' : 'Add Item' }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Detail Modal (mobile only) -->
  <div class="modal-backdrop detail-modal-backdrop" *ngIf="showItemModal && selectedItem">
    <div class="modal-dialog-centered modal-itinerary-detail">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ selectedItem.name }}</h5>
          <button type="button" class="detail-close-btn" (click)="closeItemModal()">✕</button>
        </div>
        <div class="modal-body">
          <ng-container *ngIf="getCategoryConfig(selectedItem.category) as cat">
            <div class="detail-row">
              <span class="detail-label">Category</span>
              <span class="category-badge" [style.background]="cat.bgColor" [style.color]="cat.textColor">
                {{ cat.emoji }} {{ cat.label }}
              </span>
            </div>
          </ng-container>
          <div class="detail-row" *ngIf="selectedItem.date">
            <span class="detail-label">Date</span>
            <span>{{ selectedItem.date | date:'fullDate' }}</span>
          </div>
          <div class="detail-row" *ngIf="selectedItem.time">
            <span class="detail-label">Time</span>
            <span>{{ formatTime(selectedItem.time) }}</span>
          </div>
          <div class="detail-row" *ngIf="selectedItem.location">
            <span class="detail-label">Location</span>
            <span>{{ selectedItem.location }}</span>
          </div>
          <div class="detail-row" *ngIf="selectedItem.link">
            <span class="detail-label">Link</span>
            <a [href]="selectedItem.link" target="_blank" rel="noopener noreferrer">{{ selectedItem.link }}</a>
          </div>
          <div class="detail-row" *ngIf="selectedItem.cost != null">
            <span class="detail-label">Cost</span>
            <span>{{ selectedItem.cost | currency }}</span>
          </div>
          <div class="detail-row" *ngIf="selectedItem.notes">
            <span class="detail-label">Notes</span>
            <span class="notes-text">{{ selectedItem.notes }}</span>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-outline-danger me-auto" (click)="deleteItem(selectedItem)">Delete</button>
          <button class="btn btn-secondary" (click)="closeItemModal()">Close</button>
          <button class="btn btn-primary" (click)="openEditModal(selectedItem)">Edit</button>
        </div>
      </div>
    </div>
  </div>

</div>
